import { Injectable } from '@angular/core';
import { BackendService } from '@forgerock/backstage-ui-core';
import { firstValueFrom } from 'rxjs';
import { FeaturedPage, FeaturedPageSearchResult } from './model/featured-page';

@Injectable({
  providedIn: 'root'
})
export class FeaturedPageService {
  private readonly url = '/featured-downloads-ws/api/v1/page';
  private pages?: Promise<FeaturedPage[]>;

  constructor(private readonly backend: BackendService) {}

  getFeaturedPages(): Promise<FeaturedPage[]> {
    if (!this.pages) {
      this.pages = firstValueFrom(
        this.backend.get<FeaturedPageSearchResult>(`${this.url}/_published?render=true`)
      ).then(result => result.results);
    }

    return this.pages;
  }
}
